/* eslint-disable no-else-return */
/* eslint-disable max-len */
/* eslint-disable import/no-extraneous-dependencies */
import React, { useEffect, useCallback, useContext, useState } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { WizardPage, WizardPageTemplate, wizardProps } from 'gw-portals-wizard-react';
import { useDataRefresh, ViewModelForm, ViewModelServiceContext } from 'gw-portals-viewmodel-react';
import { withAuthenticationContext } from 'gw-digital-auth-react';
import { useDependencies } from 'gw-portals-dependency-react';
import { withRouter, useHistory } from 'react-router-dom';
// eslint-disable-next-line import/no-extraneous-dependencies
import { GoogleAddressLookupComponent, initializeAddressSearchViewModel } from 'gw-ext-google-tools';
import { readViewModelValue } from 'gw-jutro-adapters-react';
import { ModalNextProvider } from '@jutro/components';
import PropertyIncident from 'gw-capability-fnol-common-react/models/PropertyIncident';
import { messages as commonMessages } from 'gw-platform-translations';
import { buildGoogleAddressRequest } from 'gw-capability-fnol-common-react/utils/SasriaAddressParserUtil';
import Claim from 'gw-capability-fnol-common-react/models/Claim';
import Address from 'gw-capability-fnol-common-react/models/Address';
import {
    isLossEstimateReqdMandatory,
    lossEstimateAmountValidation,
    validateLossEstimateInclAndExclValues,
    lossEstimateAmountIncludingVATValidation
} from 'sasria-capability-fnol-common-react/Validations/ValidationUtil';
import metadata from './SasriaContractPropertyIncident.metadata.json5';
import messages from './SasriaContractPropertyIncident.messages';
import styles from './SasriaContractPropertyIncident.module.scss';

function SasriaContractPropertyIncident(props) {
    const {
        wizardData: claimVM,
        updateWizardData,
        history: {
            location: { state = {} }
        },
        authHeader,
        propertyButtonClicked: showPropertyDiv,
        setShowPropertyDiv,
        editButtonClicked: { isIncidentEdited, expressClaimSelected },
        setIsIncidentEdited,
        setExpressClaimSelected,
        contractButtonClicked: showCWDiv,
        vehicleButtonClicked: showVehicleDiv,
        disablingNextButtonOnEdit: isPropertyEditButtonClicked,
        setIsPropertyEditButtonClicked,
        checkFinalLossEstimateValidation
    } = props;

    const history = useHistory();
    const viewModelService = useContext(ViewModelServiceContext);
    const [sasriaPropertyAddressData, setSasriaPropertyAddressData] = useState([]);
    const [sasriaAddressCodeValue, setSasriaAddressCodeValue] = useState('');
    const [showLossEstimates, setShowLossEstimates] = useState('');
    const [proprtyIncidentArray, setPropertyIncidentArray] = useState([]);
    const [addNew, setAddNew] = useState(true);

    const { FNOLService } = useDependencies('FNOLService');
    const [isLoading, setIsLoading] = useState(false);

    const propertyIncidentViewModel = viewModelService.create(
        _.get(claimVM.value, 'propertyIncident_EXT') || new PropertyIncident(),
        'cc',
        'edge.capabilities.claim.fnol.dto.PropertyIncidentDTO_EXT',
    );
    const [propertyIncidentVM] = useState(propertyIncidentViewModel);

    const addressViewModel = viewModelService.create(
        _.get(propertyIncidentVM.value, 'address') || new Address(),
        'cc',
        'edge.capabilities.address.dto.IncidentAddressDTO_EXT'
    );
    const [addressVM] = useState(addressViewModel);

    const getAddressfilter = useCallback((addressCode) => {
        return addressCode.map((key) => {
            return {
                code: key,
                name: key
            };
        });
    }, []);

    const retrievePropertyIncident = useCallback(() => {
        const lossLocation = _.get(claimVM.value, 'lossLocation');
        const addressList = [];
        if (lossLocation) {
            // eslint-disable-next-line max-len
            addressList.push(buildGoogleAddressRequest(lossLocation));
        }

        // eslint-disable-next-line no-use-before-define
        const sasriaPropertyAddressArray = getAddressfilter(addressList);
        setSasriaPropertyAddressData(sasriaPropertyAddressArray);
        // eslint-disable-next-line no-use-before-define
    }, [claimVM.value, getAddressfilter]);

    const setValuesOnPrevious = useCallback(() => {
        if (!_.isNil(_.get(propertyIncidentVM.value, 'haveLossEstimate'))) {
            const haveLossEstimate = _.get(propertyIncidentVM.value, 'haveLossEstimate');
            if (haveLossEstimate === true) {
                setShowLossEstimates('Yes');
            } else {
                setShowLossEstimates('No');
                _.set(propertyIncidentVM, 'lossEstimateValue', null);
            }
        }
    }, []);

    useEffect(() => {
        setValuesOnPrevious();
        retrievePropertyIncident();
        _.set(propertyIncidentVM.value, 'address', addressVM.value);
        _.set(claimVM.value, 'propertyIncident_EXT', propertyIncidentVM.value);
        //setAddNew(true);
        updateWizardData(claimVM);
    }, []);

    const handleLossEstimates = useCallback((value) => {
        const lossEstimatePresent = value === "Yes" ? true : false;
        _.set(propertyIncidentVM, 'haveLossEstimate', lossEstimatePresent);
        _.set(claimVM, 'lossEstimateInclVATValue', null);
        propertyIncidentVM.lossEstimateInclVATValue = null;
        setShowLossEstimates(value);
    }, [claimVM,propertyIncidentVM]);

    const writeValue = useCallback(
        (value, path) => {
            _.set(propertyIncidentVM, path, value);
            if (path === 'lossEstimateValue') {
                const lossEstimateValue = _.get(propertyIncidentVM, 'lossEstimateValue');
                if (lossEstimateValue.value === "1b") {
                    _.set(propertyIncidentVM, 'lossEstimateValue', 1000000000);
                }
                else if (lossEstimateValue.value === "1m") {
                    _.set(propertyIncidentVM, 'lossEstimateValue', 1000000);
                }
                else if (lossEstimateValue.value === "1t") {
                    _.set(propertyIncidentVM, 'lossEstimateValue', 1000000000000);
                }
                _.set(claimVM, 'lossEstimateValue', propertyIncidentVM.lossEstimateValue.value)
            }
            _.set(propertyIncidentVM.value, 'address', addressVM.value);
            _.set(claimVM.value, 'propertyIncident_EXT', propertyIncidentVM.value);
            updateWizardData(claimVM);

        },
        [claimVM, propertyIncidentVM, addressVM, updateWizardData]
    );

    const handlePropertyChange = useCallback(
        (addressIndex) => {
            setSasriaAddressCodeValue(addressIndex)
            const lossLocation = _.get(claimVM.value, 'lossLocation');
            if (lossLocation) {
                _.set(addressVM, 'unitorComplexorBranch.value', lossLocation.unitorComplexorBranch);
                _.set(addressVM, 'addressLine1.value', lossLocation.addressLine1);
                _.set(addressVM, 'suburb.value', lossLocation.suburb);
                _.set(addressVM, 'city.value', lossLocation.city);
                _.set(addressVM, 'state.value', lossLocation.state);
                _.set(addressVM, 'province.value', lossLocation.province);
                _.set(addressVM, 'postalCode.value', lossLocation.postalCode);
                _.set(propertyIncidentVM.value, 'address', addressVM.value);
                updateWizardData(claimVM);
            }
        },
        [addressVM, claimVM, propertyIncidentVM.value, updateWizardData]
    );
    const handleError = (title, message) => {
        return ModalNextProvider.showAlert({
            title: title,
            message: message,
            status: 'error',
            icon: 'mi-error-outline',
            confirmButtonText: commonMessages.ok
        }).catch(_.noop);
    };

    const individualAddress = useCallback(
        (elem) => {
            const { address } = elem;
            let res = '';
            if (address) { 
                if (address.addressLine1) res += address.addressLine1;
                if (address.addressLine2) res += address.addressLine2;
                if (address.suburb) res += address.suburb;
                if (address.city) res += address.city;
                if (address.province) res += address.province;
            }
            return res;
        },
        [],
    );

    const deleteIncidentCard = useCallback(
        (e, item, index) => {
            e.preventDefault();
            ModalNextProvider.showConfirm({
                title: 'Warning',
                message: 'Are you sure you want to remove this property incident?',
                status: 'warning',
                icon: 'mi-error-outline',
                confirmButtonText: 'Yes',
                cancelButtonText: 'No'
            }).then(async (results) => {
                if (results === 'cancel') {
                    return _.noop();
                }
                const propertyList = _.get(claimVM, 'propertyIncidentArray_EXT.value');
                propertyList.splice((index), 1);
                setPropertyIncidentArray(propertyList);
                _.set(claimVM, 'propertyIncidentArray_EXT.value', propertyList);
                checkFinalLossEstimateValidation();
                updateWizardData(claimVM);
                return true;
            }, _.noop);
        },
        [claimVM, updateWizardData, checkFinalLossEstimateValidation]
    );

    const editIncidentCard = useCallback(
        (e, item, index) => {
            e.preventDefault();
            setIsPropertyEditButtonClicked(true);
            const propertyList = _.get(claimVM, 'propertyIncidentArray_EXT.value');
            propertyList.splice((index), 1);
            setPropertyIncidentArray(propertyList);
            _.set(claimVM, 'propertyIncidentArray_EXT.value', propertyList);
            _.set(claimVM.value, 'propertyIncident_EXT', item);
            propertyIncidentVM.value = item;
            const {
                haveLossEstimate, lossEstimateValue, address, lossEstimateInclVATValue
            } = item;
            _.set(claimVM, 'haveLossEstimate', haveLossEstimate);
            _.set(claimVM, 'lossEstimateValue', lossEstimateValue);
            _.set(claimVM, 'lossEstimateInclVATValue', lossEstimateInclVATValue);
            _.set(claimVM, 'address', address);
            _.set(addressVM, 'unitorComplexorBranch.value', address.unitorComplexorBranch);
            _.set(addressVM, 'addressLine1.value', address.addressLine1);
            _.set(addressVM, 'suburb.value', address.suburb);
            _.set(addressVM, 'city.value', address.city);
            _.set(addressVM, 'state.value', address.state);
            _.set(addressVM, 'province.value', address.province);
            _.set(addressVM, 'postalCode.value', address.postalCode);
            _.set(propertyIncidentVM.value, 'address', addressVM.value);
            setShowLossEstimates(haveLossEstimate === true ? 'Yes' : 'No');
            setAddNew(true);
            setShowPropertyDiv(true);
            updateWizardData(claimVM);
        },
        [addressVM, claimVM, propertyIncidentVM.value, setIsPropertyEditButtonClicked, setShowPropertyDiv, updateWizardData]
    );


    const generatePropertycardOverrides = useCallback(() => {
        const propertyArray = _.get(claimVM.value, 'propertyIncidentArray_EXT', []);
        const overrides = propertyArray.map((elem, index) => {
            return {
                [`individuialPropertyAddress${index}`]: {
                    value: individualAddress(elem)
                },

                [`deletePropertyIncident${index}`]: {
                    onClick: (e) => {
                        deleteIncidentCard(e, elem, index);
                    }
                },

                [`editPropertyIncident${index}`]: {
                    onClick: (e) => {
                        editIncidentCard(e, elem, index);
                    }
                },

            };
        });
        return Object.assign({}, ...overrides);
    }, [claimVM.value, deleteIncidentCard, editIncidentCard, individualAddress]);


    const onNext = useCallback(() => {
        // const miscellaneous = claimVM.lossCause.value.code === 'otherobjcoll';
        const policyNumber = _.get(claimVM, 'policy.policyNumber.value');
        const isClaimNumberAvailable = _.get(claimVM, 'claimNumber.value');
        const haveLossEstimate = _.get(propertyIncidentVM, 'haveLossEstimate.value');
        const estimateAmt = _.get(propertyIncidentVM, 'lossEstimateValue.value');
        const re = new RegExp(/^(\d{1,16})(\.{0,1})(\d{0,2})?$/);

        if (_.isNull(haveLossEstimate)) {
            ModalNextProvider.showAlert({
                title: messages.mandatoryValidation,
                message: messages.haveLossEstimateMandatory,
                status: 'error',
                icon: 'mi-error-outline',
                confirmButtonText: commonMessages.ok
            }).catch(_.noop);
            return false;
        }
        if (haveLossEstimate && (_.isNull(estimateAmt) || estimateAmt === "")) {
            ModalNextProvider.showAlert({
                title: messages.mandatoryValidation,
                message: messages.lossEstimatateMandatory,
                status: 'error',
                icon: 'mi-error-outline',
                confirmButtonText: commonMessages.ok
            }).catch(_.noop);
            return false;
        } else if (haveLossEstimate && estimateAmt && estimateAmt < 1) {
            ModalNextProvider.showAlert({
                title: 'Error: Loss Estimate Validation',
                message: messages.fnolLossEstimateErrorMessage,
                status: 'error',
                icon: 'mi-error-outline',
                confirmButtonText: commonMessages.ok
            }).catch(_.noop);
            return false;
        } else if (haveLossEstimate && estimateAmt && !re.test(estimateAmt)) {
            ModalNextProvider.showAlert({
                title: 'Error: Loss Estimate Validation',
                message: messages.fnolLossEstimateErrorMessageLessThan16,
                status: 'error',
                icon: 'mi-error-outline',
                confirmButtonText: commonMessages.ok
            }).catch(_.noop);
            return false;
        }

        setIsLoading(true);
        // return FNOLService.getFNOLDetails(policyNumber, claimVM.value, authHeader)
        return FNOLService.getFNOLDetails_EXT(claimVM.value, authHeader)
            .then((response) => {
                claimVM.value = new Claim(response);
                return claimVM;
            })
            .catch((err) => {
                return history.push('/claims');
            })
            .finally(() => {
                setIsLoading(false);
            });
    }, [FNOLService, authHeader, claimVM, history, propertyIncidentVM]);

    const getAddressVisibility = useCallback((fieldPath) => {
        if (propertyIncidentVM.value) {
            const address = _.get(propertyIncidentVM.value, 'address');
            if (address) {
                const field = _.get(address, fieldPath);
                return !_.isEmpty(field) && !_.isNil(field);
            }
        }
        return false;
    }, [propertyIncidentVM]);

    const handleExclVatAmount = useCallback((value) => {
        const policy = _.get(claimVM.value, 'policyData_EXT');
        const vatPercent = _.get(policy, 'vatPercent_EXT', 0);
        const upper = Number(value) * Number(100);
        const exclValue = upper / (Number(vatPercent) + Number(100));
        _.set(propertyIncidentVM, 'lossEstimateValue.value', exclValue.toFixed(2));
        _.set(claimVM, 'lossEstimateValue', propertyIncidentVM.lossEstimateValue.value);
    }, [claimVM, propertyIncidentVM]);

    const addPropertyworkIncidentCardFunc = useCallback(
        () => {
            const haveLossEstimateVal = _.get(propertyIncidentVM, 'haveLossEstimate.value');
            const estimateAmtInclVAT = _.get(propertyIncidentVM, 'lossEstimateInclVATValue.value');
            if (haveLossEstimateVal === true){
                handleExclVatAmount(estimateAmtInclVAT);
            }
            const estimateAmt = _.get(propertyIncidentVM, 'lossEstimateValue.value');
            const propIncidentList = _.get(claimVM, 'propertyIncidentArray_EXT.value');
            if (proprtyIncidentArray.length === 0 && !_.isUndefined(propIncidentList) && propIncidentList.length >= 1) {
                proprtyIncidentArray.push(...propIncidentList);
            }
            if (!isLossEstimateReqdMandatory(haveLossEstimateVal)) return false;
            if (!lossEstimateAmountValidation(haveLossEstimateVal, estimateAmt)) return false;
            if (!lossEstimateAmountIncludingVATValidation(haveLossEstimateVal, estimateAmtInclVAT)) return false;
            if (!validateLossEstimateInclAndExclValues(haveLossEstimateVal, estimateAmt, estimateAmtInclVAT)) {
                return false;
            }
            const { haveLossEstimate, lossEstimateValue, lossEstimateInclVATValue } = propertyIncidentVM.value;
            const {
                addressLine1, addressLine2, addressLine3, suburb, province, city, state, postalCode, unitorComplexorBranch, displayName, country
            } = propertyIncidentVM.address.value;
            const address = {
                addressLine1, addressLine2, addressLine3, suburb, province, city, state, postalCode, unitorComplexorBranch, displayName, country
            };
            const contractValue = { haveLossEstimate, lossEstimateValue, address, lossEstimateInclVATValue };
            proprtyIncidentArray.push(contractValue);
            setPropertyIncidentArray(proprtyIncidentArray);
            // _.set(propertyIncidentVM.value, 'address', address);
            _.set(claimVM.value, 'propertyIncidentArray_EXT', proprtyIncidentArray);
            setAddNew(false);
            setShowPropertyDiv(false);
            propertyIncidentVM.address.addressLine1 = null;
            propertyIncidentVM.address.addressLine2 = null;
            propertyIncidentVM.address.addressLine3 = null;
            propertyIncidentVM.address.suburb = null;
            propertyIncidentVM.address.province = null;
            propertyIncidentVM.address.city = null;
            propertyIncidentVM.address.postalCode = null;
            propertyIncidentVM.address.state = null;
            propertyIncidentVM.address.unitorComplexorBranch = null;
            propertyIncidentVM.address.displayName = null;
            propertyIncidentVM.haveLossEstimate = null;
            propertyIncidentVM.lossEstimateValue = null;
            propertyIncidentVM.lossEstimateInclVATValue = null;
            setShowLossEstimates('');
            setIsIncidentEdited(true);
            setExpressClaimSelected(false);
            setIsPropertyEditButtonClicked(false);
            checkFinalLossEstimateValidation();
            updateWizardData(claimVM);
        },
        [claimVM, handleExclVatAmount, propertyIncidentVM,
            proprtyIncidentArray, setExpressClaimSelected, setIsIncidentEdited,
            setIsPropertyEditButtonClicked, setShowPropertyDiv, updateWizardData, checkFinalLossEstimateValidation],
    );

    const overrideProps = {
        haveLossEstimateId: {
            value: showLossEstimates
        },
        lossEstimate: {
            visible: false
        },

        individualPropertyIncidentCard: {
            visible: showPropertyDiv === false && showVehicleDiv === false && showCWDiv === false
        },

        propertyincidentcardbutton: {
            visible: showPropertyDiv === false && showVehicleDiv === false && showCWDiv === false
        },
        totalPage: {
            visible: showPropertyDiv === true
        },

        addressLookup: {
            model: propertyIncidentVM,
            path: initializeAddressSearchViewModel(propertyIncidentVM, 'address'),
            label: {
                "id": "fnol.common.views.fnol.Search Address",
                "defaultMessage": "Search Address"
            },
            claimModel: claimVM,
            claimModelPresent: true,
            modelPath: 'propertyIncident_EXT'
        },
        sasriaPropertAddressList: {
            availableValues: sasriaPropertyAddressData,
            value: sasriaAddressCodeValue
        },
        sasriaAddress: {
            visible: getAddressVisibility('addressLine1')
        },
        sasriaSuburb: {
            visible: getAddressVisibility('suburb')
        },
        sasriaCity: {
            visible: getAddressVisibility('city')
        },
        sasriaState: {
            visible: getAddressVisibility('state')
        },
        sasriaZipCode: {
            visible: getAddressVisibility('postalCode')
        },
        lossEstimateincludingVat: {
            visible: showLossEstimates === 'Yes'
        },
        ...generatePropertycardOverrides()
    };

    const resolvers = {
        resolveCallbackMap: {
            handlePropertyChange: handlePropertyChange,
            handleLossEstimates: handleLossEstimates,
            addPropertyworkIncidentCardFunc: addPropertyworkIncidentCardFunc
        },
        resolveComponentMap: {
            addresslookupcomponent: GoogleAddressLookupComponent
        },
        resolveClassNameMap: styles
    };

    const readValue = useCallback(
        (fieldId, path) => {
            return readViewModelValue(
                metadata.pageContent,
                claimVM,
                fieldId,
                path,
                overrideProps
            );
        },
        [claimVM, overrideProps]
    );

    return (
        <ViewModelForm
            uiProps={metadata.pageContent}
            model={claimVM}
            overrideProps={overrideProps}
            onModelChange={updateWizardData}
            callbackMap={resolvers.resolveCallbackMap}
            componentMap={resolvers.resolveComponentMap}
            classNameMap={resolvers.resolveClassNameMap}
            resolveValue={readValue}
            onValueChange={writeValue}
        //onValidationChange={onValidate}
        />
    );
}

// SasriaPropertyIncident.propTypes = wizardProps;
// SasriaPropertyIncident.propTypes = {
//     history: PropTypes.shape({
//         push: PropTypes.func
//     }).isRequired
// };
export default withRouter(withAuthenticationContext(SasriaContractPropertyIncident));